<template>
  <div>
    <v-app-bar app height="80" v-scroll="onScroll">
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/" class="hidden-sm-and-down" style="text-decoration: none">
          <span style="color: #009fe3;">SEEJC | SUM</span>
        </router-link>
        <a v-scroll-to="'#topOfApp'" class="hidden-md-and-up">
          <v-img width="100px" :src="require('@/assets/img/seejc_logo.png')"></v-img>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <div
            v-for="(item, i) in $t('items')"
            :key="i"
            style="height: 0px; margin-top: 27px; box-shadow: 0px 0px; "
        >
          <router-link :to="'/' + item.link" class="nav-act">
            <v-list class="pa-0" style="background-color: transparent">
              <v-list-item class="pl-2 pr-2">
                <v-list-item-title class="body-2">
                  <p style="font-weight: bold; color: #084776" class="text-uppercase" v-html="item.title"></p>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </router-link>
        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn
          text
          color="#009fe3"
          @click="changeLocale('hr')"
      >
        <v-icon small left>fas fa-globe-europe</v-icon>
        <span class="mr-2">HRV</span>
      </v-btn>
      <v-btn
          text
          color="#009fe3"
          @click="changeLocale('en')"
      >
        <v-icon small left>fas fa-globe-europe</v-icon>
        <span class="mr-2">ENG</span>
      </v-btn>

      <v-navigation-drawer v-model="drawer" absolute temporary app>
        <v-list-item style="height: 78px">
          <v-list-item>
            <img style="width: 100px" :src="require('@/assets/img/seejc_logo.png')"/>
          </v-list-item>

          <!-- <v-list-item-content>
            <v-list-item-title style="color: #084776">Izbornik</v-list-item-title>
          </v-list-item-content> -->
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item v-for="item in $t('items')" :key="item.title" link v-scroll-to="item.link">
            <v-list-item-icon style="width: 25px">
              <v-icon color="#084776">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-list-item-content v-on="on">
                  <v-list-item-title style="color: #084776">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
    <v-container>
      <v-row>
        <v-col cols="12" md="3" sm="4">
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-img v-if="post.images" :src="'https://web-admin.sum.ba/api/storage/' + post.images[0]"></v-img>
              <div class="font-weight-bold title text-center">{{post.title}}</div>
              <div class="subtitle-2 text-center blue--text">{{post.subtitle}}</div>
              <a class="text-decoration-none hover-box" :href="post.video" target="_blank" style="text-decoration: none">
              <div class="subtitle-2 text-center mt-4">
                <v-icon left>mdi-file-pdf-box</v-icon>Pogledajte PDF
              </div>
              </a>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="9" sm="8">
          <v-row>
            <v-col cols="12">
              <div class="subtitle-2 blue--text">{{post.subtitle}}</div>
            </v-col>
            <v-col cols="12" v-for="(item, i) in post.documents" :key="i" class="pb-0">
              <a class="text-decoration-none hover-box" :href="'https://web-admin.sum.ba/api/storage/' + item.filename" target="_blank" style="text-decoration: none">
                <div class="subtitle-1">
                  <v-icon left>mdi-file-pdf-box</v-icon>
                  {{ item.title }}
                </div>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import axios from "axios";

export default {
  name: "Arhiva",
  created() {
    this.getPost()
  },
  methods: {
    onScroll() {
      this.isScrolling =
          (window.pageYOffset || document.documentElement.scrollTop || 0) > 100;
    },
    changeLocale(locale) {
      this.languageActive = false;
      i18n.locale = locale;
      this.lang = locale.language;
    },
    async getPost() {
      let requestBody = {
        alias: this.$route.params.alias
      };
      axios
          .post("https://web-admin.sum.ba/api/web/objava", requestBody)
          .then(response => {
            this.post = response.data;
          })
      // .catch(error => console.log(error.message));
    },
  },
   data() {
    return{
      drawer: false,
      post: []
    }
   }
}
</script>

<style scoped>
.hover-box {
  color: #084776 !important;
}

.hover-box:hover i.v-icon.v-icon {
  color: red !important;
}

.hover-box:hover {
  color: red !important;
}
</style>